import { Dto, DtoWithId } from "@mango/core";
import { Relatie } from "./relatie";
import { Rubriek } from './rubriek';

@Dto({fullName: "CIJBorculo.Logic.Conditie"})
export class Conditie extends DtoWithId {
	rubriekID: Rubriek;
	relatieID: Relatie;
	korting: number;
}